import React from 'react'

function ZodiacSign() {
  return (
    <div className='h-[500px] text-center pt-[10%] bg-[#131722] text-white font-bold'>Zodiac Sign</div>
  )
}

export default ZodiacSign